import { Card, CardContent, CircularProgress, Collapse, Divider, ListItemButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import * as PXBColors from '@brightlayer-ui/colors';
import { AssetListItem } from '../../components/AssetListItem/AssetListItem';
import { ACTION_TYPE_COPY, ACTION_TYPE_NEXT, ACTION_TYPE_NONE } from '../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { ServicePartnerList } from '../../types/servicePartnerInfo-details';
import { EmptyState } from '@brightlayer-ui/react-components';
import { defaultServicePartnerDetails } from '../../state/usermanagement-state';
import { UserManagementActions } from '../../actions/actions/usermanagement-actions';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

function copyToClipboard(valueToCopy: string) {
    const tempInput = document.createElement('input')
    tempInput.value = valueToCopy
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)
}

const DeviceServiceInfoCard = () => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const [isServiceInfoVisible, setIsServiceInfoVisible] = useState(true)
    const [openServiceInfoDialogText, setOpenServiceInfoDialogText] = useState(false)
    const [deviceServiceData, setDeviceServiceData] = useState<ServicePartnerList>(defaultServicePartnerDetails)
    const servicePartnerInfoUserData = useSelector(Selectors.Usermanagement.usermanagement)


    useEffect(() => {
        if (!servicePartnerInfoUserData.ServicePartnerInfoListLoading && servicePartnerInfoUserData.ServicePartnerInfoListSuccess) {
            setDeviceServiceData(servicePartnerInfoUserData.ServicePartnerInfoListDetails)
            setOpenServiceInfoDialogText(true)
        } else if (!servicePartnerInfoUserData.ServicePartnerInfoListLoading && servicePartnerInfoUserData.ServicePartnerInfoListFail) {
            setDeviceServiceData(defaultServicePartnerDetails)
            setOpenServiceInfoDialogText(false)
            dispatch(UserManagementActions.ServicePartnerInfoListUnmounted())
        }
    }, [servicePartnerInfoUserData.ServicePartnerInfoListSuccess, servicePartnerInfoUserData.ServicePartnerInfoListLoading, servicePartnerInfoUserData.ServicePartnerInfoListFail])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {servicePartnerInfoUserData.ServicePartnerInfoListLoading && <EmptyState style={{ flex: 1, maxHeight: 500, backgroundColor: PXBColors.white[50] }}
                icon={<CircularProgress id="progress-spinner" />} title="" placeholder={undefined}
            />}

            {openServiceInfoDialogText && (
                <Card style={{ flex: '1 1 0px', overflow: 'auto' }} id="device-service-partner-Info-container" data-testid="device-service-partner-Info-container">
                    <CardContent style={{ flex: '1 1 0px', overflow: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Typography
                            variant="body2"
                            style={{
                                alignItems: 'left',
                                fontSize: 14,
                                fontWeight: 600,
                                color: PXBColors.blue[400],
                                width: '92.3%',
                            }}
                            id="service-parner-info-titleId"
                            data-testid="service-parner-info-titleId"
                        >
                            {t('SERVICEPARNTERINFO.SERVICE_INFO_HEADER')}
                        </Typography>
                        <ListItemButton
                            onClick={() => { setIsServiceInfoVisible(!isServiceInfoVisible) }}
                            id="list-header-item-button"
                            style={{
                                width: '7.41%',
                            }}
                        >
                            {isServiceInfoVisible ? (
                                <KeyboardArrowUp data-testid="arrow-up" id="list-header-up-icon" />
                            ) : (
                                <KeyboardArrowDown data-testid="arrow-down" id="list-header-down-icon" />
                            )}
                        </ListItemButton>
                    </CardContent>
                    <Divider data-testid='dividerId1' style={{ borderColor: PXBColors.gray[50] }} />
                    <Collapse in={isServiceInfoVisible} timeout="auto" unmountOnExit>
                        <AssetListItem
                            key={'service-partner-details-id'}
                            data-testid='service-partner-details-data-testid'
                            subtitle={t('REGISTRATION.STEPS.COMPANY_DETAILS')}
                            title={deviceServiceData?.companyName}
                            imageType={ACTION_TYPE_NONE}
                            divider={true}
                            titleBold={true}
                        ></AssetListItem>
                        <AssetListItem
                            key={'service-info-sla'}
                            data-testid='service-info-sla'
                            subtitle={t('ASSETS_DETAILS.SLA_SUBTITLE')}
                            title={deviceServiceData?.sLANumber}
                            imageType={ACTION_TYPE_NONE}
                            divider={true}
                            titleBold={true}
                        ></AssetListItem>
                        <AssetListItem
                            key={'contact-name-for-service-info'}
                            data-testid='contact-name-for-service-info'
                            subtitle={t('ASSETS_DETAILS.MAIN_CONTACT')}
                            title={`${deviceServiceData?.primaryFirstName} ${deviceServiceData?.primaryLastName}`}
                            imageType={ACTION_TYPE_NONE}
                            divider={false}
                            titleBold={true}
                        ></AssetListItem>
                        <AssetListItem
                            key={'phoneno-forservice-info'}
                            data-testid='phoneno-forservice-info'
                            subtitle={t('DASHBOARD.BUILDING_DETAIL_PHONE')}
                            title={`+ ${deviceServiceData?.primaryCountryCode ? deviceServiceData?.primaryCountryCode : ""} ${deviceServiceData?.primaryPhone ? deviceServiceData?.primaryPhone : ""}`}
                            imageType={ACTION_TYPE_NONE}
                            divider={false}
                            titleBold={true}
                        ></AssetListItem>
                        <AssetListItem
                            key={'email-forservice-info'}
                            data-testid='email-forservice-info'
                            subtitle={t('DASHBOARD.BUILDING_DETAIL_EMAIL')}
                            title={deviceServiceData?.primaryEmail ? deviceServiceData?.primaryEmail : ""}
                            imageType={ACTION_TYPE_COPY}
                            OnItemSelected={(): void => copyToClipboard(deviceServiceData?.primaryEmail ? deviceServiceData?.primaryEmail : "")}
                            divider={false}
                            titleBold={true}
                        ></AssetListItem>
                    </Collapse>
                </Card>
            )}

            {!openServiceInfoDialogText && <Card style={{ flex: '1 1 0px', overflow: 'auto', height: 'fit-content' }}>
                <CardContent style={{ flex: '1 1 0px', overflow: 'auto', padding: 0 }}>
                    <Typography
                        variant="body2"
                        style={{
                            alignItems: 'left',
                            fontSize: 14,
                            fontWeight: 600,
                            color: PXBColors.blue[500],
                            width: '92.3%',
                            paddingLeft: 16,
                            paddingTop: 15,
                            paddingBottom: 16,

                        }}
                        id="service-parner-info-titleId"
                        data-testid="service-parner-info-titleId"
                    >
                        {t('SERVICEPARNTERINFO.SERVICE_INFO_HEADER')}
                    </Typography>
                    <Divider data-testid='dividerId1' />
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', padding: 16 }}>
                        <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                            {t('SERVICEPARNTERINFO.SERVICE_INFO_DETAILS_NOT_AVAILABLE')}
                        </Typography>
                    </div>
                </CardContent>
            </Card>

            }

        </>
    )
}

export default DeviceServiceInfoCard
